<template>
  <div class="layout-head-banner">
    <div class="banner-container flex-between-center def-w">
      <img :src="getImgUrl(site.attr.logo.resUrl)" class="logo-view" />
      <head-search />
    </div>
  </div>
</template>

<script>
import HeadSearch from '@/layout/components/LayoutHead/HeadSearch.vue'
import { mapGetters } from 'vuex'

export default {
  name: 'HeadBanner',
  // import引入的组件需要注入到对象中才能使用
  components: { HeadSearch },
  data() {
    return {}
  },
  // 监听属性 类似于data概念
  computed: {
    ...mapGetters(['site']),
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  // 方法集合
  methods: {
    getImgUrl(val) {
      return process.env.VUE_APP_BBW_BASE + val
    },
  },
}
</script>

<style lang="scss" scoped>
.layout-head-banner {
  width: 100%;
  height: 130px;
  background-color: #e2eaf8;
  .banner-container {
    height: 100%;

    .logo-view {
      width: 570px;
      cursor: pointer;
      font-size: 0;
    }
  }
}
</style>
